import { Column, Row, FormJsonData } from 'model/Form';
import { useState, useMemo } from 'react';

export const getColClass = (width: string) => `col-md-${width}`;
export const getButtonText = (col: Column) => col.cells[0]?.element?.name ?? '';
export const isHeader = (row: Row) => row.cols[0]?.cells[0]?.element?.style?.textType === 'header';
export const isSubHeader = (row: Row) =>
  row.cols[0]?.cells[0]?.element?.style?.textType === 'subheader';
export const isNote = (row: Row) => row.cols[0]?.cells[0]?.element?.type === 'note';
export const isDescription = (row: Row) =>
  row.cols[0]?.cells[0]?.element?.style?.textType === 'body';

export const useForm = (formJson: FormJsonData) => {
  const [formData, setFormData] = useState({});

  const [salesforceFormData, setSalesforceFormData] = useState({
    records: [{}],
  });

  const [subscriptionSuccess, setSubscriptionSuccess] = useState(false);

  const [honeypotFieldValue, setHoneypotFieldValue] = useState('');

  const layout = useMemo(() => formJson?.layout, [formJson]);

  const formField = useMemo(
    () => layout?.rows?.filter(({ type }) => type === 'FormField' || !type) || [],
    [layout]
  );

  const sharedFields = useMemo(() => {
    const filteredFields = formField.filter(
      (item) => item.cols[0].cells[0].element.unique === undefined
    );

    return filteredFields.map((field) => ({
      colWidth: field.cols[0].width,
      element: field.cols[0].cells[0].element,
    }));
  }, [formField]);

  const honeypotField = useMemo(() => {
    const { isCustomHoneypotHtmlNameEnabled, customHoneypotHtmlName } = formJson || {};

    return isCustomHoneypotHtmlNameEnabled && !!customHoneypotHtmlName
      ? {
          honeypotEnabled: isCustomHoneypotHtmlNameEnabled,
          honeypotFieldName: customHoneypotHtmlName,
        }
      : undefined;
  }, [formJson]);

  const uniqueFields = useMemo(
    () =>
      formField.filter(
        (item) =>
          item.cols[0].cells[0].element.unique &&
          item.cols[0].cells[0].element.displayType !== 'hidden'
      ),

    [formField]
  );

  const bottomRows = useMemo(() => layout?.bottomRows, [layout]);

  const submitRow = useMemo(() => layout?.submitRow?.cols, [layout]);

  const getFormName = useMemo(() => formJson?.htmlName, [formJson]);

  const showForm = useMemo(() => {
    return !!layout && !!formJson?.postUrl && !!formJson?.htmlName && !!formJson?.siteId;
  }, [layout, formJson]);

  return {
    formData,
    setFormData,
    salesforceFormData,
    setSalesforceFormData,
    subscriptionSuccess,
    setSubscriptionSuccess,
    honeypotFieldValue,
    setHoneypotFieldValue,
    layout,
    formField,
    sharedFields,
    honeypotField,
    uniqueFields,
    bottomRows,
    submitRow,
    getFormName,
    showForm,
    getColClass,
    getButtonText,
    isHeader,
    isSubHeader,
    isNote,
    isDescription,
  };
};
